/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { grantControllerCreate } from '../fn/grant/grant-controller-create';
import { GrantControllerCreate$Params } from '../fn/grant/grant-controller-create';
import { grantControllerDelete } from '../fn/grant/grant-controller-delete';
import { GrantControllerDelete$Params } from '../fn/grant/grant-controller-delete';
import { grantControllerGetAll } from '../fn/grant/grant-controller-get-all';
import { GrantControllerGetAll$Params } from '../fn/grant/grant-controller-get-all';
import { grantControllerUpdate } from '../fn/grant/grant-controller-update';
import { GrantControllerUpdate$Params } from '../fn/grant/grant-controller-update';
import { GrantItem } from '../models/grant-item';
import { GrantResponse } from '../models/grant-response';

@Injectable({ providedIn: 'root' })
export class GrantService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `grantControllerGetAll()` */
  static readonly GrantControllerGetAllPath = '/grant';

  /**
   * Restituisce l'elenco dei grant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `grantControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  grantControllerGetAll$Response(params: GrantControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GrantResponse;
}>> {
    return grantControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei grant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `grantControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  grantControllerGetAll(params: GrantControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: GrantResponse;
}> {
    return this.grantControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: GrantResponse;
}>): BaseResponse & {
'data'?: GrantResponse;
} => r.body)
    );
  }

  /** Path part for operation `grantControllerCreate()` */
  static readonly GrantControllerCreatePath = '/grant';

  /**
   * Crea un grant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `grantControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  grantControllerCreate$Response(params: GrantControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GrantItem;
}>> {
    return grantControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un grant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `grantControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  grantControllerCreate(params: GrantControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: GrantItem;
}> {
    return this.grantControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: GrantItem;
}>): BaseResponse & {
'data'?: GrantItem;
} => r.body)
    );
  }

  /** Path part for operation `grantControllerDelete()` */
  static readonly GrantControllerDeletePath = '/grant/{id}';

  /**
   * Elimina un grant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `grantControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  grantControllerDelete$Response(params: GrantControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GrantItem;
}>> {
    return grantControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un grant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `grantControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  grantControllerDelete(params: GrantControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: GrantItem;
}> {
    return this.grantControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: GrantItem;
}>): BaseResponse & {
'data'?: GrantItem;
} => r.body)
    );
  }

  /** Path part for operation `grantControllerUpdate()` */
  static readonly GrantControllerUpdatePath = '/grant/{id}';

  /**
   * Modifica un grant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `grantControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  grantControllerUpdate$Response(params: GrantControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GrantItem;
}>> {
    return grantControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un grant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `grantControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  grantControllerUpdate(params: GrantControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: GrantItem;
}> {
    return this.grantControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: GrantItem;
}>): BaseResponse & {
'data'?: GrantItem;
} => r.body)
    );
  }

}
